import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, CheckCircle, Package, PhoneCall } from 'lucide-react';

const HowItWorksPage = () => {
  const steps = [
    {
      icon: <Package className="w-8 h-8" />,
      title: "Select a Package",
      desc: "Browse our collection of premium decoration setups. From budget-friendly to luxury, we have something for every dream."
    },
    {
      icon: <PhoneCall className="w-8 h-8" />,
      title: "Chat with Priya",
      desc: "Use our AI assistant or WhatsApp to share your details: Occasion, Date, and Location in Delhi NCR."
    },
    {
      icon: <Calendar className="w-8 h-8" />,
      title: "Confirm Booking",
      desc: "Once you pick your design and date, we confirm the slot. No hidden charges, just transparent pricing."
    },
    {
      icon: <CheckCircle className="w-8 h-8" />,
      title: "Sit Back & Relax",
      desc: "Our professional decorators arrive at your location and transform your space into a celebration zone!"
    }
  ];

  return (
    <div className="min-h-screen bg-slate-50 py-24 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-20">
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="font-serif-display text-4xl md:text-6xl text-slate-900 mb-6"
          >
            How It Works
          </motion.h1>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto">
            Book your perfect celebration in 4 simple steps. We handle the stress, you enjoy the magic.
          </p>
        </div>

        <div className="relative">
          {/* Connecting Line */}
          <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-0.5 bg-primary/20 -translate-x-1/2 hidden md:block" />

          <div className="space-y-12 md:space-y-24">
            {steps.map((step, i) => (
              <motion.div 
                key={i}
                initial={{ opacity: 0, x: i % 2 === 0 ? -50 : 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                className={`flex flex-col md:flex-row items-center gap-8 ${i % 2 !== 0 ? 'md:flex-row-reverse' : ''}`}
              >
                <div className="flex-1 md:text-right">
                   {i % 2 === 0 ? (
                     <div className="md:pr-12">
                       <h3 className="text-2xl font-bold text-slate-900 mb-4">{step.title}</h3>
                       <p className="text-slate-600 leading-relaxed">{step.desc}</p>
                     </div>
                   ) : null}
                </div>

                <div className="relative z-10 w-16 h-16 rounded-2xl bg-primary text-white flex items-center justify-center shadow-xl shadow-primary/30 shrink-0">
                  {step.icon}
                </div>

                <div className="flex-1 text-left">
                  {i % 2 !== 0 ? (
                    <div className="md:pl-12">
                      <h3 className="text-2xl font-bold text-slate-900 mb-4">{step.title}</h3>
                      <p className="text-slate-600 leading-relaxed">{step.desc}</p>
                    </div>
                  ) : (
                    <div className="hidden md:block" />
                  )}
                  {/* Mobile content logic */}
                  <div className="md:hidden">
                    <h3 className="text-2xl font-bold text-slate-900 mb-4">{step.title}</h3>
                    <p className="text-slate-600 leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorksPage;
